import AliceCarousel from "react-alice-carousel"
import tw from "twin.macro"
import Icon from "../../../atoms/Icon"
import { css } from "@emotion/react"
import React, { useContext, useEffect, useRef, useState } from "react"
import { TrimsCarouselProps } from "./AllVehicleExpandedSelectorModuleProps"
import { LanguageContext } from "../../../../contexts/Language"
import TrimCard from "./TrimCard"
import useViewportSize from "../../../../hooks/useViewportSize"

const TrimsCarousel: React.FC<TrimsCarouselProps> = ({
  model,
  trims,
  showCompare,
  selectedTrims,
  setSelectedTrims,
}) => {
  const { _ } = useContext(LanguageContext)
  const carousel = useRef<AliceCarousel>(null)
  const [currentItem, setCurrentItem] = useState(1)
  const [itemsPerSlide, setItemsPerSlide] = useState(3)
  const { width } = useViewportSize()
  const showNavigation = trims && trims.length > itemsPerSlide

  useEffect(() => {
    const updateItemsPerSlide = () => {
      if (window.innerWidth >= 1280) {
        setItemsPerSlide(3)
      } else if (window.innerWidth >= 768) {
        setItemsPerSlide(2)
      } else {
        setItemsPerSlide(1)
      }
    }
    updateItemsPerSlide()
    window.addEventListener("resize", updateItemsPerSlide)
    return () => window.removeEventListener("resize", updateItemsPerSlide)
  }, [])

  const chunkedItems = []
  for (let i = 0; i < trims?.length!; i += itemsPerSlide) {
    chunkedItems.push(trims?.slice(i, i + itemsPerSlide))
  }

  const items = chunkedItems.map((chunk, index) => (
    <div key={`trim-items-${index}`} css={[tw`flex`]}>
      {chunk?.map(trim => {
        const isSelected =
          selectedTrims?.findIndex(t => t.code === trim.code)! > -1
        const trimIndex = trims!.findIndex(t => t.name === trim.name) + 1

        return (
          <React.Fragment key={`trim-${trim.code}-${index}`}>
            <TrimCard
              model={model}
              trim={trim}
              index={trimIndex}
              showCompare={showCompare}
              isSelected={isSelected}
              selectedTrims={selectedTrims}
              setSelectedTrims={setSelectedTrims}
            />
          </React.Fragment>
        )
      })}
    </div>
  ))

  return (
    <div>
      <div css={[tw`flex justify-center mx-auto`]}>
        <AliceCarousel
          mouseTracking
          items={items}
          disableDotsControls
          disableButtonsControls
          paddingLeft={
            width < 768 ? 20 : width >= 768 && width < 1024 ? 65 : 90
          }
          paddingRight={
            width < 768 ? 20 : width >= 768 && width < 1024 ? 65 : 90
          }
          onSlideChanged={e => {
            setCurrentItem(e.item + e.itemsInSlide)
          }}
          ref={carousel}
        />
      </div>
      {showNavigation && (
        <div css={[tw`relative mx-auto mt-10 `]}>
          <div
            css={[
              tw`overflow-visible absolute pb-[1px] flex gap-2 content-center justify-center z-[61] bottom-0 w-full bg-white `,
            ]}
          >
            <button
              css={[
                tw`flex justify-center items-center cursor-pointer w-12 h-8 bg-gunmetal rounded-full transition-all hover:(bg-gray-400)`,
                tw`focus-visible:(bg-gray-400)`,
                tw`hover:(bg-gray-400)`,
                tw`disabled:(opacity-40 pointer-events-none)`,
              ]}
              disabled={carousel?.current?.state?.activeIndex == 0}
              onClick={e => {
                carousel?.current?.slidePrev(e)
              }}
            >
              <Icon.Chevron direction="left" color="white" css={[tw`h-4`]} />
            </button>
            {/* Progress bar that fills by % */}
            <div
              css={[
                tw`border-transparent mt-4 h-[3px] bg-gray-400  w-[200px] lg:w-[400px]`,
              ]}
            >
              <div
                css={[
                  tw`h-[5px] mt-[-1px] border border-gunmetal bg-gunmetal`,
                  css`
                    width: ${(currentItem * (100 / items.length)).toString()}%;
                  `,
                ]}
              />
            </div>
            <button
              css={[
                tw`flex justify-center items-center cursor-pointer w-12 h-8 bg-gunmetal rounded-full transition-all hover:(bg-gray-400)`,
                tw`focus-visible:(bg-gray-400)`,
                tw`hover:(bg-gray-400)`,
                tw`disabled:(opacity-40 pointer-events-none)`,
              ]}
              disabled={
                carousel?.current?.state.activeIndex == items.length - 1
              }
              onClick={e => carousel?.current?.slideNext(e)}
            >
              <Icon.Chevron direction="right" color="white" css={[tw`h-4`]} />
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default TrimsCarousel
